export default "__VITE_PUBLIC_ASSET__f340b058__"